module.exports = __webpack_public_path__ + "static/media/company-image.ea533f55.png";